module.exports = __webpack_public_path__ + "media/images/lb/202-c963366796cf80ef355f744f60e3733b.svg";